export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";

export const RESET_USER_REQUEST = "RESET_USER_REQUEST";
export const RESET_USER_SUCCESS = "RESET_USER_SUCCESS";
export const RESET_USER_FAILURE = "RESET_USER_FAILURE";